import { errorMsg } from '../constants/messages';

const HeroImageFormData = [
    {
        title: 'Header Image Details',
        name: 'name',
        label: 'Header Name',
        fieldType: {
            name: 'select',
            options: [],
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Header Name', allowAddRecordClick: true },
        isTableHeader: true,
        isAccordian: true,
    },
    {
        name: 'description',
        label: 'Description',
        fieldType: {
            name: 'multipleTextInput',
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Description', allowAddRecordClick: false },
        isTableHeader: true,
        isAccordian: true,
    },
    {
        name: 'desktopPngUrl',
        label: 'Desktop Image(Png)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: true,
        isAccordian: true,
    },
    {
        name: 'desktopWebPUrl',
        label: 'Desktop Image(WebP)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Desktop Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: true,
    },
    {
        name: 'mobilePngUrl',
        label: 'Mobile Image(Png)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(Png)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: true,
    },
    {
        name: 'mobileWebPUrl',
        label: 'Mobile Image(WebP)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: true,
    },
    {
        name: 'imageInfo',
        label: 'Image Info',
        fieldType: {
            name: 'text',
        },
        required: false,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image Info', allowAddRecordClick: true },
        isTableHeader: false,
        isAccordian: true,
    },
    // Additional fields for careersHeader - Desktop Image 2
    {
        name: 'desktopPngUrl2',
        label: 'Desktop Image 2 (PNG)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: false,
        errorMsg: errorMsg,
        tableMeta: {
            title: 'Desktop Image 2 (PNG)',
            enableSort: false,
            allowAddRecordClick: false,
            columnType: 'image',
        },
        isTableHeader: false,
        isAccordian: false, // Will be conditionally set to true for careersHeader
    },
    {
        name: 'desktopWebPUrl2',
        label: 'Desktop Image 2 (WebP)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: false,
        errorMsg: errorMsg,
        tableMeta: {
            title: 'Desktop Image 2 (WebP)',
            enableSort: false,
            allowAddRecordClick: false,
            columnType: 'image',
        },
        isTableHeader: false,
        isAccordian: false, // Will be conditionally set to true for careersHeader
    },
    {
        name: 'mobilePngUrl2',
        label: 'Mobile Image 2 (PNG)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: false,
        errorMsg: errorMsg,
        tableMeta: {
            title: 'Mobile Image 2 (PNG)',
            enableSort: false,
            allowAddRecordClick: false,
            columnType: 'image',
        },
        isTableHeader: false,
        isAccordian: false, // Will be conditionally set to true for careersHeader
    },
    {
        name: 'mobileWebPUrl2',
        label: 'Mobile Image 2 (WebP)',
        fieldType: {
            name: 'uploadImage',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: false,
        errorMsg: errorMsg,
        tableMeta: {
            title: 'Mobile Image 2 (WebP)',
            enableSort: false,
            allowAddRecordClick: false,
            columnType: 'image',
        },
        isTableHeader: false,
        isAccordian: false, // Will be conditionally set to true for careersHeader
    },
];

export { HeroImageFormData };
